import React, { useEffect, useState } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    GetApp,
    DynamicFeed,
    QuestionAnswer
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useMemo } from "react";
import formService from "../../../services/form.service";
import { useErrorHandler } from "../../../hooks";
import FormSectionsPage from "./form-section/index"
import FormAnswersPage from "./form-answers";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
        active: true,
    },
    {
        title: "توضیحات",
        field: "description",
        active: false,
    },
    {
        title: "لینک فرم",
        field: "formLink",
    },
];

export default function FormPage() {

    const errorHandler = useErrorHandler();

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await formService.deleteForm(item.id);
        if(res.error){
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "description",
                title: "توضیحات",
                mainField: false,
            },
            {
                field: "isActiveText",
                title: "وضعیت",
                mainField: false,
            },
            {
                field: "createDate",
                title: "تاریخ ایجاد",
                mainField: false,
            },
            {
                field: "formLink",
                title: "لینک فرم",
                mainField: false,
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await formService.getForms();
        if (error) {
            return;
        }

        setData(data.items.map(item => ({ 
            ...item,
            isActiveText: item.isActive ? "فعال" : "غیرفعال",
            formLink: `/forms/${item.id}`
        })));
    };

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                onRefresh={onRefresh}
                handleChangeSearchBar={setSearch}
                rowActions={[
                    {
                        icon: <DynamicFeed />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <FormSectionsPage {...props} />,
                    },
                    {
                        icon: <QuestionAnswer />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <FormAnswersPage {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد فرم",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="فرم"
            />
        </div>
    );
}
